@if (algemeneMeldingen) {
  <mat-nav-list>
    <mat-list-item class="no-list-item-highlight allow-button-shadow-overflow"
      disableRipple>
      <div matListItemTitle class="mat-small">
        <h3 class="no-padding-left subheader">Algemene meldingen</h3>
      </div>
      @if (canManageAlgemeneMeldingen()) {
        <span matListItemMeta>
          <button mat-mini-fab
            color="accent"
            (click)="onAddClick()">
            <mat-icon>add</mat-icon>
          </button>
        </span>
      }
    </mat-list-item>
    @for (melding of algemeneMeldingen; track getAlgemeneMeldingId($index, melding); let isLast = $last) {
      <mat-list-item (click)="onMeldingClick(melding)">
        @if (canManageAlgemeneMeldingen()) {
          <mat-icon
            matListItemIcon
            fontSet="material-icons-outlined">
            {{ melding.isActief() ? 'visibility' : 'visibility_off' }}
          </mat-icon>
        }
        <div matListItemTitle>{{ melding.getContent() }}</div>
        <div matListItemLine class="mat-small">
          {{ melding.getActiefVanDag() | zahPeriode: melding.getActiefTotDag() }}
        </div>
        <button matListItemMeta
          class="center-vertically"
          [disableRipple]="true"
          [class.hidden]="!canManageAlgemeneMeldingen()"
          mat-icon-button
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu"
          xPosition="before"
          overlapTrigger="true">
          <a mat-menu-item
            (click)="onEditClick(melding)">
            <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
            <span>Wijzigen</span>
          </a>
          <a mat-menu-item
            (click)="onDeleteClick(melding)">
            <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
            <span>Verwijderen</span>
          </a>
        </mat-menu>
      </mat-list-item>
      @if (!isLast) {
        <mat-divider></mat-divider>
      }
    }
    @if (algemeneMeldingen.length === 0) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen algemene meldingen</div>
      </mat-list-item>
    }
    <mat-divider></mat-divider>
  </mat-nav-list>
}
